import request from '@/units/request';

export default {
  order:{
    // 订单详情 
    detail: (id) =>
      request({
        url: 'contract.order/getDetail',
        method: 'GET',
        params: {
          id: id,
        },
      }),
    // 订单列表 
    list: (params) =>
      request({
        url: 'contract.order/index',
        method: 'GET',
        params,
        custom: {
          showLoading: false,
        },
      }),
    // 创建订单 
    create: (data) =>
      request({
        url: 'contract.order/placeOrder',
        method: 'POST',
        data,
      }),
  },
  info:{
    // 订单详情 
    detail: (id) =>
      request({
        url: 'contract.info/getDetail',
        method: 'GET',
        params: {
          id: id,
        },
      }),
    // 订单列表 
    list: (params) =>
      request({
        url: 'contract.info/getList',
        method: 'GET',
        params,
        custom: {
          showLoading: false,
        },
      }),
    // 上传合同 
    saveFile: (data) =>
      request({
        url: 'contract.info/saveFile',
        method: 'POST',
        data,
      }),
  }
  
};
